// extracted by mini-css-extract-plugin
export default {"container":"regionSettings_container__zDeOJ","linksWrapper":"regionSettings_linksWrapper__7+ruV","linkWrapper":"regionSettings_linkWrapper__gInyo"};